import { useGuardAuthedOnly } from "modules/auth";
import { HeaderDashboard, HeaderTitle, Sidebar, WithSidebarContainer } from "modules/layout";
import { useRouter } from "next/router";
import pages from "pages/_router";
import React from "react";
import { api } from "shared/api";
import styles from "./_layout.module.scss";

interface IProfileLayout {
  children: React.ReactNode;
}

const ProfileLayout = (props: IProfileLayout) => {
  useGuardAuthedOnly();
  const router = useRouter();
  const profile = api.userProfile.useUserProfileMe();

  return (
    <div className={styles.profile_page}>
      <HeaderDashboard />
      <HeaderTitle className={styles.header}>Профиль</HeaderTitle>
      <WithSidebarContainer
        mainHref={pages.profile.href}
        sidebar={
          <Sidebar
            mainHref={pages.profile.href}
            menu={[
              { label: "Настройки", href: pages.profile.href, exact: true, additionalHref: pages.profile.settings },
              { label: "Выход", href: pages.logout.href },
            ]}
          />
        }
      >
        {props.children}
      </WithSidebarContainer>
    </div>
  );
};

export default ProfileLayout;
